import React from 'react';
import { Row, Col, Icon } from '../../../importCL';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';
import { wrapTrademarkSuperscript } from '../../../utils/cob-utils';

const ApprovedPendingFunding = ({
    fundingWarning,
    iconDesktop,
    selectedCard,
    applicationCode,
}) => {
    return (
        <>
            {fundingWarning && (
                <Row className='m-0'>
                    <Col className='ConfirmationPageHero__fundingWarningContainer !px-0' lg={12} md={12}>
                        <div className='ConfirmationPageHero__fundingWarning'>
                            <Icon src={iconDesktop} size='utility' />
                            <span>
                                {transformHTMLParserLinks(wrapTrademarkSuperscript(fundingWarning))}
                            </span>
                        </div>
                    </Col>
                </Row>
            )}
            
            <Row>
                <Col
                    id='applicationCode'
                    className='ConfirmationPageHero__applicationCode'
                    lg={12} md={12}
                >
                    Application Code: <strong>{applicationCode}</strong>
                </Col>
            </Row>
            
            {selectedCard?.isPremium && selectedCard?.fee > 0 && (
                <Row>
                    <Col className='ConfirmationPageHero__cardDesign' lg={12} md={12}>
                        Card Design: <strong>{selectedCard.name} (${selectedCard.fee})</strong>
                    </Col>
                </Row>
            )} 
        </>
    );
};

export default ApprovedPendingFunding;